module.exports = __webpack_public_path__ + "assets/img/13.24aa6b91.png";